import {
  addingTeethOnExistingDentureItemSchema,
  getBaseProductSchema,
  ItemTypeEnum,
  productPreferencesSchema,
  ProductTypeEnum,
  type AddingTeethOnExistingDentureProduct,
} from "@jasper/client-models";
import {
  isTeethStepComplete,
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { PreferencesStep, ToothStep } from "./constants";

export type AddingTeethOnExistingDentureStepKey =
  typeof StepKeysEnum.tooth | typeof StepKeysEnum.preferences;

export const AddingTeethOnExistingDentureWorkflowConfiguration: ProductWorkflowConfiguration<
  AddingTeethOnExistingDentureProduct,
  AddingTeethOnExistingDentureStepKey
> = {
  productType: ProductTypeEnum.addingTeethOnExistingDenture,
  itemType: ItemTypeEnum.addingTeethOnExistingDenture,
  steps: [new ToothStep(), new PreferencesStep()],
  teethSelection: TeethSelectionEnum.MIXED,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({
      itemSchema: addingTeethOnExistingDentureItemSchema,
    }).safeParse(product).success;
  },

  getCompletedSteps(product) {
    const completed: AddingTeethOnExistingDentureStepKey[] = [];

    if (
      isTeethStepComplete({
        teeth: product.teeth,
        teethSelection: this.teethSelection,
      })
    ) {
      completed.push(StepKeysEnum.tooth);
    }

    const isPreferencesStepComplete =
      productPreferencesSchema.safeParse(product).success;

    if (isPreferencesStepComplete) {
      completed.push(StepKeysEnum.preferences);
    }

    return completed;
  },
};
